var exports = {
  "Gf": "FriendsListSection.module__sectionTitle___MlI0WG",
  "f5": "FriendsListSection.module__sectionContent___MlI0WG",
  "v2": "FriendsListSection.module__sectionContentWithMargin___MlI0WG",
};

module.exports = exports;
